import { alias, createModelSchema, identifier, reference } from "serializr";
import { Cloneable } from "@/common/Cloneable";
import { Schema } from "@/common/Schema";

export class SmartOfferBundleAlchemyLevelCauldronKind extends Cloneable {

    static NONE = new SmartOfferBundleAlchemyLevelCauldronKind(0, "NONE");
    static TYPE_1 = new SmartOfferBundleAlchemyLevelCauldronKind(1, "TYPE_1");
    static TYPE_2 = new SmartOfferBundleAlchemyLevelCauldronKind(2, "TYPE_2");
    static TYPE_3 = new SmartOfferBundleAlchemyLevelCauldronKind(3, "TYPE_3");
    static TYPE_4 = new SmartOfferBundleAlchemyLevelCauldronKind(4, "TYPE_4");
    static TYPE_5 = new SmartOfferBundleAlchemyLevelCauldronKind(5, "TYPE_5");

    static _values = [
        this.NONE,
        this.TYPE_1,
        this.TYPE_2,
        this.TYPE_3,
        this.TYPE_4,
        this.TYPE_5
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferBundleAlchemyLevelCauldronKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferBundleAlchemyLevelCauldronKind) {
            return SmartOfferBundleAlchemyLevelCauldronKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferBundleAlchemyLevelCauldronKind.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    equal(value) {
        if (value instanceof SmartOfferBundleAlchemyLevelCauldronKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleAlchemyLevelCauldronKind());
        } else if (target instanceof SmartOfferBundleAlchemyLevelCauldronKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleAlchemyLevelCauldronKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});
